import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import NavBar from '@/components/NavBar';
import DashboardPublic from '@/components/DashboardPublic';
import DashboardAuth from '@/components/DashboardAuth';
import { useUser } from '@clerk/clerk-react';

/**
 * Main landing page component that renders different content
 * based on user authentication status
 */
const Index = () => {
  const navigate = useNavigate();
  const { isLoaded, isSignedIn, user } = useUser();

  useEffect(() => {
    // Handle OAuth redirect with code param (Schwab)
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const session = params.get('session');
    if (code) {
      // Redirect to Schwab Dashboard route with query params
      navigate(`/schwabdashboard?code=${encodeURIComponent(code)}${session ? `&session=${encodeURIComponent(session)}` : ''}`);
      return;
    }

    const handleIntersection = (entries: IntersectionObserverEntry[]) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in');
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    });

    const animatedElements = document.querySelectorAll('.animate-on-scroll');
    animatedElements.forEach(el => {
      el.classList.add('opacity-0');
      observer.observe(el);
    });

    return () => {
      animatedElements.forEach(el => observer.unobserve(el));
    };
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col">
      <NavBar />
      <main className={user ? 'pt-20' : ''}>
        {!isLoaded ? (
          <div className="container mx-auto p-4 flex justify-center items-center min-h-screen">
            <div className="animate-pulse h-24 w-24 rounded-full bg-gray-200"></div>
          </div>
        ) : isSignedIn ? (
          <DashboardAuth />
        ) : (
          <DashboardPublic />
        )}
      </main>
    </div>
  );
};

export default Index;
